import { supportedLanguages } from '@common'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

import { Logout } from '@/components/Icons'
import { LanguageSelector } from '@/features/Footer/LanguageSelector'
import { LoginButton } from '@/features/header/LoginButton'
import { LOGIN_STATUS } from '@/features/user/userSlice'
import { useAppSelector } from '@/utils/useAppSelector'

import { useLocale } from '../../locale/useLocale'

import styles from './Actions.module.scss'

interface Props {
  closeMenu: () => void
}

const Actions = ({ closeMenu }: Props) => {
  const t = useTranslations()
  const isLoggedIn = useAppSelector((state) => state.user.loginStatus === LOGIN_STATUS.LOGGED_IN)
  const locale = useLocale()
  const isRTL = supportedLanguages[locale].rightToLeft

  return (
    <div className={styles.Actions}>
      {!isLoggedIn && <LoginButton additionalClasses={styles.LoginButton} onClick={closeMenu} />}
      <LanguageSelector id="menu-language-selector" isMobileNav />
      {isLoggedIn && (
        <Link className={styles.LogoutButton} data-cy="account-logout" href="/oauth/logout">
          <Logout />
          {!isRTL ? `${t('switch_acc')} / ${t('logout')}` : `${t('logout')} / ${t('switch_acc')}`}
        </Link>
      )}
    </div>
  )
}

export default Actions
